export default __webpack_public_path__ + "static/media/lightcloud.43642252.mp4";